/* jshint esversion: 6 */
/* jshint ignore:start */
import { useState } from 'react';
const ImageLoad = ({ BaseUrl, url, CustomeStyle }) => {

    const [imgLoaded, setImgLoaded] = useState(false);

    return (
        <img
            src={`${BaseUrl}/${url}`}
            alt="Model"
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
            className={`${CustomeStyle} transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    )
}

export default ImageLoad;
/* jshint ignore:end */